module.exports = __webpack_public_path__ + "static/media/droplet.80a4eaee.svg";